import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2ListRequest,
    Mk2Response,
    Pagination,
    SortDirectionFinancing
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

import {
    Client,
    ClientFilters,
    Clients,
    GetClientsRequest,
    GetClientsResponse
} from '../../_generated';
import { ASAP_API_SERVICE_NAME, SortDirection } from '../constants/common-constants';

export class ListAsapClientsRequest extends Mk2ListRequest implements GetClientsRequest {
    pagination?: Pagination;
    clientFilter?: ClientFilters;

    constructor(initial?: Partial<ListAsapClientsRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class ListAsapClientsResponse extends Mk2Response<Client> implements GetClientsResponse {
    pagination?: Pagination;
    rows?: Client[];
    totalCount?: number;
    allFilteredKeys?: number[];

    constructor(initial?: Partial<ListAsapClientsResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }

    get clients(): Clients {
        return this.rows;
    }
}

@Injectable({ providedIn: 'root' })
export class ListAsapClientsService extends ApiService<
    ListAsapClientsRequest,
    ListAsapClientsResponse
> {
    public requestType = ListAsapClientsRequest;
    public responseType = ListAsapClientsResponse;
    public endpointName = 'v1/purchasing/auto-approval/getClients';
    public serviceName = ASAP_API_SERVICE_NAME;
    public usePascalForUrl = false;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }

    public requestMapper(req: ListAsapClientsRequest): GetClientsRequest {
        let sortDirection: SortDirection;
        if (
            req.pagination != null &&
            req.pagination.sortDirection == SortDirectionFinancing.DESCENDING
        ) {
            sortDirection = SortDirection.Descending;
        } else {
            sortDirection = SortDirection.Ascending;
        }

        return {
            pagination: {
                sortColumn: req.pagination != null ? req.pagination.sortColumn : null,
                sortDirection: sortDirection,
                take: req?.pagination?.take,
                skip: req?.pagination?.skip
            },
            clientFilter: req.clientFilter
        };
    }

    public responseMapper(response: unknown): ListAsapClientsResponse {
        const apiResponse = response as GetClientsResponse;
        return new ListAsapClientsResponse({
            totalCount: apiResponse.totalCount ? apiResponse.totalCount : 0,
            rows: apiResponse.clients ? apiResponse.clients : [],
            allFilteredKeys: apiResponse.allFilteredKeys ? apiResponse.allFilteredKeys : []
        });
    }
}
